import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './shop-grid.css';
import './PropertyList.css';
import './productsliderV1.css';
import NavbarV2 from '../global-components/navbar-v5';
import Footer_v1 from '../global-components/footer';
import parse from 'html-react-parser';
import { faBed, faBath, faCamera, faImages, faMapMarkedAlt, faMapMarkerAlt, faListAlt, faHeart } from '@fortawesome/free-solid-svg-icons';
import { useFavorites } from '../global-components/FavoritesContext';
import axios from 'axios';
import './shop-grid.css';
import './PropertyList.css';
import Slider from "rc-slider";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import '../section-components/filterprix.css';
import { useLocation } from "react-router-dom";

const ProductDetails = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]); // Tous les produits triés
  const [currentPage, setCurrentPage] = useState(1); // Page actuelle pour la navigation
  const [error, setError] = useState(null);
  const [agent, setAgent] = useState(null);
  
  const [sortMethod, setSortMethod] = useState("relevance");
  const [selectedPriceRange, setSelectedPriceRange] = useState([0, 10000]);
  const location = useLocation();
  const filters = location.state || {};
  const [properties, setProperties] = useState([]);
  const propertiesPerPage = 1; // 1 produit par page
  const [totalProperties, setTotalProperties] = useState(0);
  const [priceRange, setPriceRange] = useState(location.state?.priceRange || [10000, 990000000]);

  const [activeTab, setActiveTab] = useState('sommaire');
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [isPriceFilterOpen, setIsPriceFilterOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tempPriceRange, setTempPriceRange] = useState([0, 10000]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [minLotSize, setMinLotSize] = useState("");
  const [maxLotSize, setMaxLotSize] = useState("");
  const [minDate, setMinDate] = useState("");
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions([]);
      return;
    }

    const fetchSuggestions = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/search-predictive', {
          params: { query },
        });
        setSuggestions(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des suggestions', error);
      }
    };

    fetchSuggestions();
  }, [query]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Effet pour récupérer les produits depuis le backend
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products');
        setProducts(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des produits:', error);
      }
    };
    fetchProducts();
  }, []);

  const [category, setCategory] = useState("Résidentiel");
  const [transactionType, setTransactionType] = useState("À vendre");
  const [price, setPrice] = useState("");
  const [lifestyleFilters, setLifestyleFilters] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Remonter en haut quand on change de page
  };
  
  let publicUrl = process.env.PUBLIC_URL + '/'

  const handleCardClick = async (item) => {
    try {
      navigate(`/results/${encodeURIComponent(item)}`);
    } catch (error) {
      console.error("Erreur lors de la redirection :", error);
    }
  };

  const handleApplyFilter = async () => {
    try {
      console.log("Application du filtre avec la plage de prix :", priceRange);
      const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/filtre", {
        params: {
          minPrice: priceRange[0],
          maxPrice: priceRange[1],
          transactionType: "rent",
        },
      });
      setProducts(response.data);
      setIsPriceFilterOpen(false);
    } catch (error) {
      console.error("Erreur lors de l'application du filtre :", error);
    }
  };

  const { favorites, addFavorite, removeFavorite } = useFavorites();

  const toggleFavorite = (productId) => {
    if (favorites.includes(productId)) {
      removeFavorite(productId);
    } else {
      addFavorite(productId);
    }
  };
  
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleFavoriteClick = (product) => {
    if (!isLoggedIn) {
      setShowLoginPrompt(true);
      return;
    }
    toggleFavorite(product._id);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);
  
  const [activeProductId, setActiveProductId] = useState(null);

  useEffect(() => {
    const fetchTotalProducts = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products/count');
        setTotalProperties(response.data.total);
      } catch (error) {
        console.error('Erreur lors de la récupération du total des produits :', error);
      }
    };
    fetchTotalProducts();
  }, []);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        console.log("Filtres envoyés :", filters);
        const params = {
          transactionType: "rent",
          address: filters.address?.trim() !== "" ? filters.address : undefined,
          minPrice: filters.priceRange ? filters.priceRange[0] : undefined,
          maxPrice: filters.priceRange ? filters.priceRange[1] : undefined,
        };
        const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/filtre", { params });
        console.log("Réponse reçue :", response.data);
        setProperties(response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des propriétés :", error);
      }
    };
    fetchProperties();
  }, [filters]);

  useEffect(() => {
    const fetchFilteredProducts = async () => {
      try {
        const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/products/prix", {
          params: {
            minPrice: priceRange ? priceRange[0] : 0,
            maxPrice: priceRange ? priceRange[1] : 10000,
          },
        });
        setProducts(response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des produits :", error);
      }
    };
    if (priceRange) {
      fetchFilteredProducts();
    }
  }, [priceRange]);
  
  const handleTransactionChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "sale") {
      navigate("/vendre");
    } else if (selectedValue === "rent") {
      navigate("/louer");
    }
  };
  
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionClick = (route) => {
    setIsOpen(false);
    navigate(route);
  };

  const [isResidentialOpen, setIsResidentialOpen] = useState(false);
  const [isRentOpen, setIsRentOpen] = useState(false);
  const residentialDropdownRef = useRef(null);
  const rentDropdownRef = useRef(null);

  const handleResidentialClick = () => {
    setIsResidentialOpen(!isResidentialOpen);
    setIsRentOpen(false);
  };

  const handleRentClick = () => {
    setIsRentOpen(!isRentOpen);
    setIsResidentialOpen(false);
  };

  const handleClickOutside = (event) => {
    if (residentialDropdownRef.current && !residentialDropdownRef.current.contains(event.target)) {
      setIsResidentialOpen(false);
    }
    if (rentDropdownRef.current && !rentDropdownRef.current.contains(event.target)) {
      setIsRentOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchSortedProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/sorts', {
        params: { sort: sortMethod },
      });
      setProducts(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des produits triés :", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSortedProducts();
  }, [sortMethod]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSortChange = (method) => {
    setSortMethod(method);
    setIsDropdownOpen(false);
  };

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  
  const handleToggleFilterModal = () => {
    setIsFilterModalOpen(!isFilterModalOpen);
  };
  
  const [isPropertyTypeOpen, setIsPropertyTypeOpen] = useState(false);
  const handleTogglePropertyType = () => {
    setIsPropertyTypeOpen(!isPropertyTypeOpen);
  };
  
  const [isCharacteristicsOpen, setIsCharacteristicsOpen] = useState(false);
  const handleToggleCharacteristics = () => {
    setIsCharacteristicsOpen(!isCharacteristicsOpen);
  };

  const [isBuildingOpen, setIsBuildingOpen] = useState(false);
  const handleToggleBuilding = () => {
    setIsBuildingOpen(!isBuildingOpen);
  };

  const [isOtherCriteriaOpen, setIsOtherCriteriaOpen] = useState(false);
  const handleToggleOtherCriteria = () => {
    setIsOtherCriteriaOpen(!isOtherCriteriaOpen);
  };

  const handleFilterChange = (type) => {
    setSelectedPropertyTypes((prevTypes) =>
      prevTypes.includes(type)
        ? prevTypes.filter((t) => t !== type)
        : [...prevTypes, type]
    );
  };

  const [selectedCharacteristics, setSelectedCharacteristics] = useState([]);
  
  const handleCharacteristicsChange = (event) => {
    const value = event.target.value;
    setSelectedCharacteristics((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };
  
  const [selectedStructureTypes, setSelectedStructureTypes] = useState([]);

  const handlePropertyTypeChange = (type) => {
    setSelectedPropertyTypes((prevTypes) =>
      prevTypes.includes(type)
        ? prevTypes.filter((t) => t !== type)
        : [...prevTypes, type]
    );
  };
  
  const handleStructureTypeChange = (event) => {
    const value = event.target.value;
    setSelectedStructureTypes((prev) =>
      prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
    );
  };

  const handleSearch = () => {
    let searchTerms = [];
    if (selectedPropertyTypes.length > 0) {
      searchTerms.push(`types=${selectedPropertyTypes.join(",")}`);
    }
    if (selectedStructureTypes.length > 0) {
      searchTerms.push(`structureTypes=${selectedStructureTypes.join(",")}`);
    }
    const searchQuery = searchTerms.length > 0 ? searchTerms.join("&") : "all";
    const targetUrl = `/resultss/${encodeURIComponent(searchQuery)}`;
    console.log("🔍 Naviguer vers :", targetUrl);
    navigate(targetUrl);
  };
  
  const handleSearch1 = () => {
    let searchTerms = [];
    if (minLotSize) {
      searchTerms.push(`minLotSize=${minLotSize}`);
    }
    if (maxLotSize) {
      searchTerms.push(`maxLotSize=${maxLotSize}`);
    }
    if (minDate) {
      searchTerms.push(`minDate=${minDate}`);
    }
    const searchQuery = searchTerms.length > 0 ? searchTerms.join("&") : "all";
    const targetUrl = `/results/${encodeURIComponent(searchQuery)}`;
    console.log("🔍 URL générée :", targetUrl);
    navigate(targetUrl);
  };
  
  const handleResetFilters = () => {
    setSelectedPropertyTypes([]);
    setSelectedStructureTypes([]);
    setMinLotSize("");
    setMaxLotSize("");
    setMinDate("");
  };

  const filteredProducts = products.filter((product) => {
    const isTransactionTypeValid = product.transactionType === "rent";
    const isAddressValid = filters.address && filters.address.trim() !== ""
      ? product.address.toLowerCase().includes(filters.address.toLowerCase())
      : true;
    const isPriceValid = filters.priceRange
      ? product.price >= filters.priceRange[0] && product.price <= filters.priceRange[1]
      : true;
    return isTransactionTypeValid && isAddressValid && isPriceValid;
  });
  
  const filteredAndSortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortMethod === "price_asc") {
      return a.price - b.price;
    } else if (sortMethod === "price_desc") {
      return b.price - a.price;
    } else {
      return new Date(b.publicationDate) - new Date(a.publicationDate);
    }
  });
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  
  const filterModalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterModalRef.current && !filterModalRef.current.contains(event.target)) {
        setIsFilterModalOpen(false);
      }
    }
    if (isFilterModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFilterModalOpen]);

  const cardRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        setIsPriceFilterOpen(false);
      }
    }
    if (isPriceFilterOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPriceFilterOpen]);

  // 👉 Récupérer tous les produits triés du plus récent au plus ancien
  useEffect(() => {
    const fetchLatestProducts = async () => {
      setLoading(true);
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products');
        
        if (response.data.length > 0) {
          // Trier les produits par date de création décroissante
          const sortedProducts = response.data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          
          setProducts(sortedProducts);
          setTotalProperties(sortedProducts.length); // Mettre à jour le nombre total de produits
          setCurrentPage(1); // Commencer avec la première page
        }
        setLoading(false);
      } catch (error) {
        console.error('Erreur lors de la récupération des produits:', error);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchLatestProducts();
  }, []);

  // 👉 Récupérer les détails de l'agent immobilier associé
  useEffect(() => {
    const storedAgent = localStorage.getItem("agent");
    if (storedAgent && storedAgent !== "undefined") {
      try {
        const parsedAgent = JSON.parse(storedAgent);
        setAgent(parsedAgent);
      } catch (error) {
        console.error("Erreur lors du parsing de l'agent :", error);
      }
    }
  }, []);

  // 👉 Calculer l'index du produit actuel basé sur la page
  const currentProductIndex = currentPage - 1;
  const currentProduct = products[currentProductIndex];

  // 👉 Gestion du chargement et des erreurs
  if (loading) {
    return <p>Chargement...</p>;
  }

  if (error) {
    return <p>Erreur: {error}</p>;
  }

  if (!currentProduct) {
    return <p>Aucun produit disponible.</p>;
  }

  // 👉 Redirection vers WhatsApp pour contacter l'agent
  const handleButtonClick = () => {
    const phoneNumber = "772977043";
    const message = "Bonjour, je suis intéressé(e) par votre propriété.";
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <div>
      <NavbarV2/>
      <div className="ltn__product-area ltn__product-gutter mb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Search Widget */}
              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <input
                  type="text"
                  placeholder="Chercher par ville, quartier, région, adresse ou N° Keurgui"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  className="input-style"
                />
                
                {/* Dropdown Résidentiel */}
                <div ref={residentialDropdownRef} style={{ position: "relative", display: "inline-block" }}>
                  <button
                    onClick={handleResidentialClick}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "white",
                      color: "black",
                      border: "none",
                      borderRadius: "30px",
                      cursor: "pointer",
                      display: "flex",
                      border: "1px solid #ddd",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    Résidentiel
                    <span style={{
                      transform: isResidentialOpen ? "rotate(180deg)" : "rotate(0deg)",
                      fontWeight: "300",
                      fontSize: "12px",
                      lineHeight: "1",
                    }}>
                      ▼
                    </span>
                  </button>
                  {isResidentialOpen && (
                    <ul style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      backgroundColor: "white",
                      padding: "10px",
                      border: "1px solid #ddd",
                      zIndex: 1000,
                      listStyleType: "none",
                    }}>
                      <li onClick={() => handleOptionClick("/louer")}>Résidentiel</li>
                      <li onClick={() => handleOptionClick("/commercial")}>Commercial</li>
                    </ul>
                  )}
                </div>
                
                {/* Type de transaction */}
                <div ref={rentDropdownRef} style={{ position: "relative", display: "inline-block" }}>
                  <button
                    onClick={handleRentClick}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "white",
                      color: "black",
                      border: "none",
                      borderRadius: "30px",
                      cursor: "pointer",
                      display: "flex",
                      border: "1px solid #ddd",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    Louer
                    <span style={{
                      transform: isResidentialOpen ? "rotate(180deg)" : "rotate(0deg)",
                      fontWeight: "300",
                      fontSize: "12px",
                      lineHeight: "1",
                    }}>
                      ▼
                    </span>
                  </button>
                  {isRentOpen && (
                    <ul style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      backgroundColor: "white",
                      padding: "10px",
                      border: "1px solid #ddd",
                      zIndex: 1000,
                      listStyleType: "none",
                    }}>
                      <li onClick={() => handleOptionClick("/louer")}>À louer</li>
                      <li onClick={() => handleOptionClick("/vendre")}>À vendre</li>
                    </ul>
                  )}
                </div>

                {/* Prix */}
                <button
                  className="button-style" 
                  style={{ color: 'black' }}
                  onClick={() => setIsPriceFilterOpen(!isPriceFilterOpen)}
                >
                  Prix
                </button>

                {isPriceFilterOpen && (
                  <div ref={cardRef} className="price-filter-card" style={{ marginTop: "15px", marginRight: "-10px" }}>
                    <h4>Prix</h4>
                    <Slider
                      range
                      value={priceRange}
                      min={0}
                      max={10000}
                      step={100}
                      onChange={(value) => setPriceRange(value)}
                    />
                    <div className="price-inputs">
                      <div className="price-input">
                        <span>{priceRange[0].toLocaleString()} </span>
                      </div>
                      <div className="price-input">
                        <span>{priceRange[1].toLocaleString()}</span>
                      </div>
                    </div>
                    <div className="filter-buttons">
                      <button
                        className="close-button"
                        onClick={() => setIsPriceFilterOpen(false)}
                      >
                        Fermer
                      </button>
                      <button
                        className="apply-button"
                        onClick={handleApplyFilter}
                      >
                        Appliquer
                      </button>
                    </div>
                  </div>
                )}

                {/* Filtres */}
                <button
                  className="button-style" 
                  style={{ color: 'black' }}
                  onClick={handleToggleFilterModal}
                >
                  Filtres
                </button>

                {/* Modal pour les filtres */}
                {isFilterModalOpen && (
                  <div ref={filterModalRef} className="filter-modal" style={{ marginTop: '-260px', marginLeft: '200px' }}>
                    <div className="filter-options">
                      <div className="filter-item">
                        <div className="filter-item-header">
                          <span className="filter-item-title">Type d'habitat</span>
                          <button
                            className="expand-button"
                            onClick={handleTogglePropertyType}
                          >
                            {isPropertyTypeOpen ? "-" : "+"}
                          </button>
                        </div>
                        {isPropertyTypeOpen && (
                          <div className="checkbox-group">
                            <div>
                              <label>
                                <input
                                  type="checkbox"
                                  value="appartement"
                                  onChange={() => handlePropertyTypeChange("appartement")}
                                  checked={selectedPropertyTypes.includes("appartement")}
                                />
                                Appartement
                              </label>
                              <label>
                                <input
                                  type="checkbox"
                                  onChange={() => handleFilterChange("bureau_commerce")}
                                  checked={selectedPropertyTypes.includes("bureau_commerce")}
                                />
                                Bureau / Commerce
                              </label>
                              <label>
                                <input
                                  type="checkbox"
                                  onChange={() => handleFilterChange("hotel_restaurant")}
                                  checked={selectedPropertyTypes.includes("hotel_restaurant")}
                                />
                                Hotel / Restaurant
                              </label>
                            </div>
                            <div>
                              <label>
                                <input
                                  type="checkbox"
                                  onChange={() => handleFilterChange("studio_chambre")}
                                  checked={selectedPropertyTypes.includes("studio_chambre")}
                                />
                                Studio / Chambre
                              </label>
                              <label>
                                <input
                                  type="checkbox"
                                  onChange={() => handleFilterChange("villa_maison")}
                                  checked={selectedPropertyTypes.includes("villa_maison")}
                                />
                                Villa / Maison
                              </label>
                              <label>
                                <input
                                  type="checkbox"
                                  onChange={() => handleFilterChange("terrain")}
                                  checked={selectedPropertyTypes.includes("terrain")}
                                />
                                Terrain
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                      
                      <div className="filter-item">
                        <div className="filter-item-header">
                          <span className="filter-item-title">Caractéristiques</span>
                          <button
                            className="expand-button"
                            onClick={handleToggleCharacteristics}
                          >
                            {isCharacteristicsOpen ? "-" : "+"}
                          </button>
                        </div>
                        {isCharacteristicsOpen && (
                          <div className="checkbox-group">
                            <label>
                              <input
                                type="checkbox"
                                value="Bord de l'eau"
                                checked={selectedStructureTypes.includes("Bord de l'eau")}
                                onChange={handleStructureTypeChange}
                              />
                              Bord de l'eau
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                value="Accès à l'eau"
                                checked={selectedStructureTypes.includes("Accès à l'eau")}
                                onChange={handleStructureTypeChange}
                              />
                              Accès à l'eau
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                value="Plan d'eau navigable"
                                checked={selectedStructureTypes.includes("Plan d'eau navigable")}
                                onChange={handleStructureTypeChange}
                              />
                              Plan d'eau navigable
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                value="Villégiature"
                                checked={selectedStructureTypes.includes("Villégiature")}
                                onChange={handleStructureTypeChange}
                              />
                              Villégiature
                            </label>
                          </div>
                        )}
                      </div>
                    
                      <div className="filter-item">
                        <div className="filter-item-header">
                          <span className="filter-item-title">Autres Critères</span>
                          <button
                            className="expand-button"
                            onClick={handleToggleOtherCriteria}
                          >
                            {isOtherCriteriaOpen ? "-" : "+"}
                          </button>
                        </div>
                        {isOtherCriteriaOpen && (
                          <div className="other-criteria-content">
                            <div className="criteria-inputs">
                              <label>
                                Superficie du terrain (m²)
                                <div className="input-group">
                                  <input
                                    type="number"
                                    placeholder="Min (m²)"
                                    value={minLotSize}
                                    onChange={(e) => setMinLotSize(e.target.value)}
                                    className="input-box"
                                  />
                                  <span>à</span>
                                  <input
                                    type="number"
                                    placeholder="Max (m²)"
                                    value={maxLotSize}
                                    onChange={(e) => setMaxLotSize(e.target.value)}
                                    className="input-box"
                                  />
                                </div>
                              </label>
                            </div>
                            <div className="criteria-dates">
                              <label>
                                Nouveau depuis
                                <div className="input-group">
                                  <input
                                    type="date"
                                    value={minDate}
                                    onChange={(e) => setMinDate(e.target.value)}
                                    className="input-box"
                                  />
                                  <span className="calendar-icon">📅</span>
                                </div>
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="filter-actions">
                      <button 
                        className="filter-button-common reset-button"
                        onClick={handleResetFilters}
                      >
                        Réinitialiser
                      </button>
                      <button className="filter-button-common close-button" onClick={handleToggleFilterModal}>
                        Fermer
                      </button>
                    </div>
                    <br/>
                    <button
                      className="search-btton"
                      onClick={() => {
                        if (selectedPropertyTypes.length > 0 || selectedStructureTypes.length > 0) {
                          handleSearch();
                        }
                        if (minLotSize || maxLotSize || minDate) {
                          handleSearch1();
                        }
                      }}
                      style={{
                        backgroundColor: "#975D23",
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Rechercher
                    </button>
                  </div>
                )}
              </div>
            </div>
            
            {query.length >= 3 && (
              <>
                {suggestions.length > 0 ? (
                  <div className="search-results-container">
                    {suggestions.map((item, index) => (
                      <div
                        key={index}
                        className="result-card"
                        onClick={() => handleCardClick(item)}
                      >
                        <div className="result-card-content">
                          <h5>{item}</h5>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="search-results-container">
                    <div className="result-card">
                      <div className="result-card-content">
                        <h5 style={{ color: "red" }}>Aucun Résultat</h5>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            {/* Barre des onglets */}
            <div className="tabs-container">
              <div className="tabs">
                <Link
                  to="/louer"
                  className={`tab-button ${activeTab === 'galerie' ? 'active' : ''}`}
                  onClick={() => handleTabClick('galerie')}
                >
                  <FontAwesomeIcon icon={faImages} /> Galerie
                </Link>
                <Link
                  to="/carte"
                  className={`tab-button ${activeTab === 'carte' ? 'active' : ''}`}
                  onClick={() => handleTabClick('carte')}
                >
                  <FontAwesomeIcon icon={faMapMarkedAlt} /> Carte
                </Link>
                <Link
                  to="/sommaire"
                  className={`tab-button ${activeTab === 'sommaire' ? 'active' : ''}`}
                  onClick={() => handleTabClick('sommaire')}
                >
                  <FontAwesomeIcon icon={faListAlt} /> Sommaire
                </Link>
                <div
                  className="tab-indicator"
                  style={{ left: `${getIndicatorPosition(activeTab)}%` }}
                ></div>
              </div>
            </div>

            {/* Pagination - Navigation entre les produits */}
            <div className="pagination-container">
              <button
                className="pagination-button"
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              >
                «
              </button>
              <button
                className="pagination-button"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                ‹
              </button>
              <span className="pagination-info">
                {currentPage} / {Math.ceil(totalProperties / propertiesPerPage)}
              </span>
              <button
                className="pagination-button"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === Math.ceil(totalProperties / propertiesPerPage)}
              >
                ›
              </button>
              <button
                className="pagination-button"
                onClick={() => handlePageChange(Math.ceil(totalProperties / propertiesPerPage))}
                disabled={currentPage === Math.ceil(totalProperties / propertiesPerPage)}
              >
                »
              </button>
            </div>
            
            <div className="col-lg-12">
              <div className="product-details-page">
                {/* En-tête avec titre et détails */}
                <div className="product-header">
                  <div className="product-header-content">
                    <div className="product-info-left">
                      <h6>{currentProduct.title}</h6>
                      <h5 className="address">
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> {currentProduct.address}, {currentProduct.city}
                      </h5>
                    </div>
                    <div className="product-info-center">
                      <span className="price">{currentProduct.price?.toLocaleString()} FCFA</span>
                    </div>
                    <div className="product-info-right">
                      <button
                        className="contact-agent-btn"
                        onClick={handleButtonClick}
                        style={{ backgroundColor: '#975d23', color: 'white' }}
                      >
                        Contacter le courtier immobilier
                      </button>
                    </div>
                  </div>
                </div>

                {/* Galerie d'images */}
                <div className="product-gallery">
                  {currentProduct.images?.length > 0 && (
                    <a href={currentProduct.images[0]} data-rel="lightcase:myCollection" className="large-image">
                      <img src={currentProduct.images[0]} alt="Large Product" />
                    </a>
                  )}

                  <div className="small-images">
                    {currentProduct.images?.slice(1, 5).map((image, index) => (
                      <a href={image} data-rel="lightcase:myCollection" key={index}>
                        <img src={image} alt={`Small Product ${index + 1}`} />
                      </a>
                    ))}
                  </div>
                </div>

                {/* Détails du produit */}
                <div className="property-details">
                  <h2>Caractéristiques</h2>
                  <div className="features-grid">
                    <div className="feature">
                      <p><strong>Chambres :</strong> <FontAwesomeIcon icon={faBed} /> {currentProduct.features?.bedrooms || 0}</p>
                    </div>
                    <div className="feature">
                      <p><strong>Salles de bain :</strong> <FontAwesomeIcon icon={faBath} /> {currentProduct.features?.bathrooms || 0}</p>
                    </div>
                    <div className="feature">
                      <p><strong>Superficie :</strong> {currentProduct.features?.area || "Non spécifiée"} m²</p>
                    </div>
                    <div className="feature">
                      <p><strong>Type :</strong> {currentProduct.category || "Inconnu"}</p>
                    </div>
                  </div>

                  <h3>Description</h3>
                  <p>{currentProduct.description || "Aucune description disponible."}</p>
                </div>

                {/* Détails de l'agent immobilier */}
                <h3>Courtier immobilier</h3>
                <div className="ltn-author-introducing clearfix">
                  <div className="author-img">
                    <img src={agent?.photoProfil || "assets/img/blog/author.jpg"} alt="Photo de l'agent" />
                  </div>
                  <div className="author-info">
                    <h6>Agent Immobilier</h6>
                    <h2>{agent ? agent.agentName : "Nom inconnu"}</h2>
                    <div className="footer-address">
                      <ul>
                        <li>
                          <div className="footer-address-icon">
                            <i className="icon-placeholder" />
                          </div>
                          <div className="footer-address-info">
                            <p>{agent ? agent.territoire : "Localisation inconnue"}</p>
                          </div>
                        </li>
                        <li>
                          <div className="footer-address-icon">
                            <i className="icon-call" />
                          </div>
                          <div className="footer-address-info">
                            <p><a href={`tel:${agent ? agent.phoneNumber : "+000-000000"}`}>
                              {agent ? agent.phoneNumber : "Numéro inconnu"}
                            </a></p>
                          </div>
                        </li>
                        <li>
                          <div className="footer-address-icon">
                            <i className="icon-mail" />
                          </div>
                          <div className="footer-address-info">
                            <p><a href={`mailto:${agent ? agent.email : "example@example.com"}`}>
                              {agent ? agent.email : "Email inconnu"}
                            </a></p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer_v1/>
    </div>
  );
  
  function getIndicatorPosition(tab) {
    switch (tab) {
      case 'galerie':
        return 0;
      case 'carte':
        return 33.33;
      case 'sommaire':
        return 66.66;
      default:
        return 0;
    }
  }
};

export default ProductDetails;